import { Spinner } from '@insify/ui';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useInvoices } from '../../../api/queries/useInvoices';
import { CenterAlignedContainer } from '../../../components/CenterAlignedContainer';
import { InvoiceList } from '../../../components/InvoiceList';
import { useUiStore } from '../../../stores/uiStore';

import styles from './styles.module.css';

const InvoicesPage = () => {
  const { t } = useTranslation('invoice');
  const { data: invoices = [], isLoading } = useInvoices();
  const setNotification = useUiStore((state) => state.setNotification);
  const resetNotification = useUiStore((state) => state.resetNotification);

  useEffect(() => {
    setNotification(t('invoice_disclaimer'));

    return resetNotification;
  }, [setNotification, resetNotification, t]);

  if (isLoading) {
    return (
      <div className={styles.spinner}>
        <Spinner />
      </div>
    );
  }

  if (invoices.length === 0) {
    return <h2>{t('no_invoice')}</h2>;
  }

  return (
    <CenterAlignedContainer>
      <InvoiceList invoices={invoices} />
    </CenterAlignedContainer>
  );
};

export { InvoicesPage };
